// src/components/Header/Header.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <nav className="nav">
        <ul className="nav-list">
          <li className="nav-item">
            <NavLink exact="true" to="/" activeClassName="active">
              Reporte Profesional
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/palet-production" activeClassName="active">
              Producción de Palets
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/meca-production" activeClassName="active">
              Producción Mecánica
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/loquesea" activeClassName="active">
              Búsqueda de Stock
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/leandro" activeClassName="active">
              Control Diario de Producción
            </NavLink>
          </li>
          {/* Agrega más enlaces aquí si tienes más vistas */}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
